// extracted by mini-css-extract-plugin
export var locationCard = "_qz-0";